export const campaignConfig = {
    campaignListConfig: 'campaign_devapp', // campaign_devapp
    searchConfigList: 'campaign_burgerking_{tier}_search',
    subscriptionConfig: 'campaign_burgerking_subscription',
};

export const dashboardConfig = {
    nationwideWelcome: 'burgerking_nationwide_welcome_web',
    touristWelcome: 'burgerking_tourist_welcome_web',

    // homeDashboard: 'burgerking_{tier}_web',
    homeDashboard: 'burgerking_nationwide_web',
    freshTasteDashboard: 'burgerking_freshtaste',
    madeToOrderDashboard: 'burgerking_madetoorder',
    promotionDashboard: 'burgerking_promotion',
    cateringDashboard: 'burgerking_catering',
};

export const categoryConfig = {
    menuCategory: 'menu_devapp',
    menuCategoryReward: 'menu_burgerking_rewards',
    menuCategoryHome: 'menu_burgerking_{tier}',
};

export const historyConfig = {
    purchase: 'purchase',
    purchase_used: 'purchase_used',
    purchase_unused: 'purchase_unused',
};

export const couponConfig = {
    coupon: 'campaign_coupon',
    coupon_delivery: 'campaign_coupon_delivery',
    coupon_pickup: 'campaign_coupon_pickup',
};

export const googleMapKey = {
    //googleKey: 'AIzaSyCkSuK3_iO0O-P9wtVod6qRVALFS0KT6e8',
    googleKey: 'AIzaSyBfA5UUAPA-mrkbW8OREim4bfoHva17RfM',
};
